<template>
  <div class="col-sm-4 details__thumb">
    <img :src="artwork.imagePreviewUrl"/>
  </div>
</template>

<script>
  export default {
    name: 'ArtworkImage',
    props: {
      artwork: {
        type: Object,
        required: true,
      },
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/search_page/index/components/artworks_tab/row/artwork_image.vue?557843ea